import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { uploadToADLS } from "../bondRetrievalUtils";
import { buildProbatePayload } from "../bondRetrievalPayloadBuilders";
import { calculatePremium } from "../../../../globals/utils/commons";
import useBondRetrieveBase from "./useBondRetrieveBase";

function useProbateBondRetrieve() {
  const { role } = useSelector((state) => state.auth);
  const teamMemberId = useSelector((state) => state.teamMember.teamMemberId);
  const [teamMember, setTeamMember] = useState(null);

  useEffect(() => {
    if (role === "carrier_team_member") {
      setTeamMember(teamMemberId);
    }
  }, [role, teamMember, teamMemberId]);

  const buildPayload = useCallback(
    (globalState, status, billingMethod, isIndemnityReceived) =>
      buildProbatePayload(globalState, status, billingMethod, isIndemnityReceived),
    []
  );

  return useBondRetrieveBase("probate", {
    buildPayload,
    calculateCorrectionPremium: (amount) => calculatePremium(amount),
    extraReturn: () => ({
      teamMember,
      teamMemberId,
      uploadToADLS,
    }),
  });
}

export default useProbateBondRetrieve;
